import request from '@/config/axios'
export const getTemplatePage = (params: any) => request.get({ url: '/live/template/page', params })
export const createTemplate = (data: any) => request.post({ url: '/live/template/create', data })
export const updateTemplate = (data: any) => request.put({ url: '/live/template/update', data })
export const deleteTemplate = (id: number) =>
  request.delete({ url: '/live/template/delete', params: { id } })
